import { Component } from '@angular/core';

@Component({
  selector: 'ns-privacy',
  template: require('./privacy.component.html')
})
export class PrivacyComponent {
}
